import React, { useState } from "react";
import { Container, Row, Col, Form, Card, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";
import axios from "axios";
import apiConfig from "./apiConfig";
function ChangePassword() {
  const navigate = useNavigate();
  
  const [show, setShow] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const validationSchema = Yup.object({
        currentPassword: Yup.string().required("Current password is required"),
    password: Yup.string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])[^"]{8,}$/,
        "Password should contain at least one uppercase, one lowercase, one number, one special character, and must not contain spaces"
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      email: "dummyuser@email.com",
      currentPassword: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const userId = localStorage.getItem("userId");
      console.log(userId);
      try {
        // Simulating a successful password change
        setLoading(true);
        const response = await axios.post(
          `${apiConfig.baseURL}/changePassword`,
          {
            
              id: userId,
              currentPassword: values.currentPassword,
              newPassword: values.password,
              confirmPassword: values.confirmPassword,
          },
          {
            headers: {
                "x-api-key": apiConfig["x-api-key"],
                "Content-Type": "application/json"
            }
        }
      );
      if(response.status === 200){
        console.log("Password changed successfully for:", values.email);
        localStorage?.removeItem("tempmail");
        toast.success("Password set successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        navigate("/");}
      } catch (error) {
        console.log(error);
        toast.error("Password setting failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    },
  });

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

  return (
    <motion.div initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="credential-page">
      <Container>
        <Row className="justify-content-md-center" style={{ alignItems: "center", minHeight: "90vh" }}>
          <Col xs lg="6">
            <Card className="border-0">
              <h2 className="fw-bolder mb-4 card-title text-center">Create New Password</h2>
              <Alert variant="warning" className="mb-3" onClose={() => setShow(false)} dismissible>
                Use 8+ characters with at least 1 uppercase, 1 lowercase, 1 number, and 1 special character
              </Alert>
              <Form onSubmit={formik.handleSubmit}>
                                 {/* Current Password Field */}
                                 <Form.Group
                                  className="mb-4 position-relative"
                                  controlId="formCurrentPassword"
                                >
                                  <Form.Control
                                    type={showCurrentPassword ? "text" : "password"}
                                    name="currentPassword"
                                    placeholder="Current Password"
                                    className="p-3"
                                    value={formik.values.currentPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    isInvalid={
                                      formik.touched.currentPassword &&
                                      formik.errors.currentPassword
                                    }
                                  />
                                  <i
                                    onClick={() =>
                                      setShowCurrentPassword(!showCurrentPassword)
                                    }
                                    className="password-icon"
                                    style={{ position: "absolute", right: "31px", top: "15px" }}
                                  >
                                    {showCurrentPassword ? <BsEyeSlash /> : <BsEye />}
                                  </i>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.currentPassword}
                                  </Form.Control.Feedback>
                                </Form.Group>
                <Form.Group className="mb-4 position-relative" controlId="formBasicPassword">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="New Password"
                    className="p-3 password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    isInvalid={formik.errors.password}
                  />
                  <i onClick={togglePasswordVisibility} className="password-icon" style={{ position: "absolute", right: "31px", top: "15px" }}>
                    {showPassword ? <BsEyeSlash /> : <BsEye />}
                  </i>
                  <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3 position-relative" controlId="formBasicConfirmPassword">
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    className="p-3 password"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    isInvalid={formik.errors.confirmPassword}
                  />
                  <i onClick={toggleConfirmPasswordVisibility} className="password-icon" style={{ position: "absolute", right: "31px", top: "15px" }}>
                    {showConfirmPassword ? <BsEyeSlash /> : <BsEye />}
                  </i>
                  <Form.Control.Feedback type="invalid">{formik.errors.confirmPassword}</Form.Control.Feedback>
                </Form.Group>
                <Button type="submit" variant="secondary" size="lg" className="rounded-pill text-white font-16 px-5 py-3 w-100">
                  Set Password
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </motion.div>
  );
}

export default ChangePassword;